import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

// 翻译数据
const translations = {
  zh: {
    // 导航
    overview: '首页',
    aiDiagnosis: 'AI诊断',
    newsIntelligence: 'AI新闻资讯',
    shortTermPrediction: '短期预测',
    strategyMatching: '策略匹配',
    sagaxAgent: 'SAGAX 定制投研',

    // AI新闻资讯
    newsIntelTitle: 'AI新闻资讯',
    newsIntelDesc: '全球市场新闻动态，AI 智能分析与情感研判',
    newsMapView: '地图监控',
    newsListView: '列表',
    globalNewsMonitor: '全球新闻监控',
    newsCount: '篇新闻',
    regionsCount: '个区域',
    autoRefresh: '自动刷新',
    totalArticles: '总文章数',
    signalCount: '信号数',
    sourceCount: '数据源',
    sourceDistribution: '数据源分布',
    bullish: '利多',
    bearish: '利空',
    neutral: '中性',
    breaking: '突发',
    noNewsData: '暂无新闻数据',
    loadingGlobalNews: '加载全球新闻...',
    articleDetail: '新闻详情',
    viewSource: '原文',
    noContent: '暂无正文内容',
    aiCredibility: 'AI 可信度评估',
    overall: '综合',
    sourceLabel: '来源',
    contentLabel: '内容',
    stockImpact: '个股影响评估',
    searchNews: '搜索新闻...',
    impact: '影响',
    readMore: '查看原文 →',
    // 新闻分类
    catAll: '全部',
    catMacro: '宏观',
    catPolicy: '政策',
    catIndustry: '行业',
    catCompany: '公司公告',
    catMarket: '市场',
    catCentralBank: '央行',
    catEarnings: '财报',
    catGeopolitical: '地缘',
    catInvestmentBank: '投行视野',
    // 新闻地图分类模式
    filterByType: '按类型',
    filterByRegion: '按地域',
    // 地区
    regionAll: '全球',
    regionChina: '中国',
    regionAsiaPacific: '亚太',
    regionNorthAmerica: '北美',
    regionEurope: '欧洲',
    regionMiddleEast: '中东',
    majorIndices: '主要指数',
    realTimeData: '实时数据',
    marketStatistics: '市场统计',
    hotStocks: '热门股票',
    gainersList: '涨幅榜',
    losersList: '跌幅榜',
    totalVolume: '总成交量',
    totalAmount: '总成交额',
    risingStocks: '上涨家数',
    fallingStocks: '下跌家数',
    flatStocks: '平盘家数',
    tradingDate: '交易日期',
    noMarketData: '暂无市场数据',
    noGainersData: '暂无涨幅榜数据',
    noLosersData: '暂无跌幅榜数据',
    gainersCount: '涨幅榜数量',
    losersCount: '跌幅榜数量',
    
    // AI诊断
    aiDiagnosisCenter: 'AI诊断中心',
    intelligentQuantitativeAnalysis: '智能量化分析，精准投资决策',
    aiDescription: '基于先进的人工智能技术，为您的投资决策提供全方位的智能分析服务。从估值测试到趋势识别，再到综合评估，让AI成为您最可靠的投资伙伴。',
    valuationTest: '估值测试',
    trendRecognition: '趋势识别',
    comprehensiveEvaluation: '综合评估',
    usageInstructions: '使用说明',
    quickStart: '快速开始',
    technicalFeatures: '技术特点',
    step1: '选择您需要的分析模块',
    step2: '输入股票代码或期货代码',
    step3: '获取AI智能分析结果',
    deepLearningAlgorithm: '深度学习算法',
    realTimeDataProcessing: '实时数据处理',
    multiDimensionalAnalysis: '多维度分析',

    // 策略匹配
    strategyDescription: '我们的投资经理提供跨投资方法、风格和资产类别的多样化策略。',
    approach: '投资方法',
    style: '投资风格',
    assetClass: '资产类别',
    reset: '重置',
    activeStrategies: '活跃策略',
    averagePerformance: '平均表现',
    
    // 策略匹配详细翻译
    discretionary: '自主投资',
    multiManager: '多管理人',
    quantitative: '量化投资',
    alternative: '另类投资',
    longOnly: '多头策略',
    privateMarkets: '私募市场',
    equity: '股票',
    credit: '信用',
    multiAsset: '多资产',
    realEstate: '房地产',
    performance: '表现',
    risk: '风险',
    status: '状态',
    active: '活跃',
    low: '低',
    medium: '中',
    high: '高',
    trendFollowing: '趋势跟踪',
    trendFollowingLiquid: '趋势跟踪流动性',
    trendFollowingOTC: '趋势跟踪场外',
    catastropheBond: '巨灾债券',
    multiStrategy: '多策略',
    systematicMacro: '系统宏观',
    targetClimate: '目标气候',
    longOnlyStrategy: '多头策略',
    
    // 股票预测相关
    futuresHeatmap: 'A股热力图',
    stockHeatmap: 'A股热力图',
    futuresHeatmapDescription: '基于AI的A股短期价格预测热力图',
    stockHeatmapDescription: '基于AI的A股短期价格预测热力图',
    fiveDayPriceChange: '五日价格变化热力图',
    clickFuturesCode: '点击股票代码查看详细的时间价格序列预测',
    clickStockCode: '点击股票代码查看详细的时间价格序列预测',
    falling: '下跌',
    rising: '上涨',
    green: '绿色',
    white: '白色',
    red: '红色',
    changeRange: '涨跌幅热力图 (±10%)',
    varietyDate: '股票/日期',
    updateTime: '更新时间',
    clickFuturesCodeDetail: '点击股票代码可查看详细的时间价格序列预测',
    clickStockCodeDetail: '点击股票代码可查看详细的时间价格序列预测',
    colorDepth: '颜色深浅表示涨跌幅度，数值表示置信度',
    predictionAutoRefresh: '数据每30秒自动刷新，基于AI模型实时预测',
    
    // 股票详情
    currentPrice: '当前价格',
    volume: '成交量',
    peRatio: '市盈率',
    pbRatio: '市净率',
    totalMarketValue: '总市值',
    circulatedMarketValue: '流通市值',
    openInterest: '持仓量',
    margin: '保证金',
    ratio: '比例',
    contractInfo: '合约信息',
    contractSize: '合约规格',
    minTickSize: '最小变动价位',
    tradingVariety: '交易品种',
    exchange: '交易所',
    hand: '手',
    exportData: '导出',
    share: '分享',
    dataExportInDevelopment: '数据导出功能开发中...',
    linkCopied: '链接已复制到剪贴板',
    oneDay: '1天',
    threeDays: '3天',
    fiveDays: '5天',
    sevenDays: '7天',
    oneMonth: '1个月',
    unknownFutures: '未知股票',
    unknownStock: '未知股票',
    unknown: '未知',
    unknownExchange: '未知交易所',
    
    // 趋势识别
    commodityTrendRecognition: '商品趋势识别',
    commodityTrendDescription: '基于AI的商品期货趋势分析工具',
    inputArea: '输入区域',
    futuresSelection: '期货选择',
    futuresCode: '期货代码',
    quickSelection: '快速选择',
    selectFutures: '选择期货',
    startTrendAnalysis: '开始趋势分析',
    analyzing: '分析中...',
    viewHeatmap: '查看热力图',
    resultArea: '结果区域',
    analysisResult: '分析结果',
    futuresInfo: '期货信息',
    code: '代码',
    name: '名称',
    currentPriceValue: '当前价格',
    technicalIndicators: '技术指标',
    bollUpper: '布林上轨',
    bollLower: '布林下轨',
    trendAnalysis: '趋势分析',
    trendDirection: '趋势方向',
    trendStrength: '趋势强度',
    supportLevel: '支撑位',
    resistanceLevel: '阻力位',
    detailedAnalysis: '详细分析',
    noDetailedAnalysis: '暂无详细分析',
    pleaseSelectFutures: '请选择期货并开始分析',
    enterFuturesCode: '请输入期货代码',
    analysisFailed: '分析失败',
    getFuturesListFailed: '获取期货列表失败',
    
    // 数据处理
    dataProcessing: '数据处理',
    dataProcessingDescription: '智能数据获取、清洗和指标计算',
    dataProcessingModule: '数据处理模块',
    dataProcessingInDevelopment: '该模块正在开发中，将提供智能的数据处理功能',
    dataAcquisition: '数据获取',
    indicatorCalculation: '指标计算',
    
    // 因子看板
    factorDashboard: '因子看板',
    factorDashboardDescription: '因子看板及分析说明',
    factorDashboardAnalysis: '因子看板及分析说明',
    factorDashboardPlaceholder: '因子看板功能开发中，将提供全面的因子分析功能',
    configuration: '配置',
    category: '分类',
    selectAll: '全选',
    deselectAll: '全不选',
    stockPool: '股票池',
    backtestPeriod: '回测周期',
    portfolioConstruction: '组合构建',
    transactionCosts: '手续费及滑点',
    filterStocks: '过滤涨停及停牌股',
    factorData: '因子数据',
    minQuantileReturn: '最小分位数超额年化收益率',
    maxQuantileReturn: '最大分位数超额年化收益率',
    minQuantileTurnover: '最小分位数换手率',
    maxQuantileTurnover: '最大分位数换手率',
    irValue: 'IR值',

    // 自动化交易
    automatedTrading: '自动化交易',
    automatedTradingDescription: '全自动交易执行和风险管理',
    automatedTradingModule: '自动化交易模块',
    automatedTradingInDevelopment: '该模块正在开发中，将提供全自动的交易执行功能',
    autoTrading: '自动交易',
    riskControl: '风险控制',
    
    // 通用
    symbol: 'symbol',
    switchToEnglish: '切换到英文',
    switchToChinese: 'Switch to Chinese',
    chinese: '中',
    english: 'EN',
    loading: '加载中...',
    noData: '暂无数据',
    error: '错误',
    success: '成功',
    cancel: '取消',
    confirm: '确认',
    save: '保存',
    edit: '编辑',
    delete: '删除',
    search: '搜索',
    filter: '筛选',
    refresh: '刷新',
    more: '更多',
    back: '返回',
    next: '下一步',
    previous: '上一步',
    close: '关闭',
    open: '打开',
    view: '查看',
    download: '下载',
    upload: '上传',
    export: '导出',
    import: '导入',

    // Factor Agent
    factorGeneration: '因子生成',
    factorGenerationDesc: '通过自然语言描述，AI自动生成量化因子代码并评测',
    factorReview: '因子审核',
    factorReviewDesc: '查看、审核和管理AI生成的因子',
    generateFactor: '生成因子',
    factorDescription: '因子描述',
    factorName: '因子名称',
    factorType: '因子类型',
    dependencies: '数据依赖',
    generating: '生成中...',
    compositeScore: '综合评分',
    backtestMetrics: '回测指标',
    verificationChecks: '验证检查',
    icMean: 'IC均值',
    icRatio: '信息比率',
    icWinRate: 'IC胜率',
    sharpeRatio: '夏普比率',
    approveAndRegister: '审核通过并入库',
    rejectFactor: '驳回',
    pendingReview: '待审核',
    approved: '已通过',
    rejected: '已驳回',
    iterationHistory: '迭代历史',
    generatedCode: '生成代码',
    explanation: '因子说明',
    registeredFactors: '已入库因子',

    // 设置页面
    settings: '设置',
    apiKeyManagement: 'API Key 管理',
    createApiKey: '创建 API Key',
    apiKeyList: 'API Key 列表',
    apiKeyName: 'API Key 名称',
    tierBasic: '基础版',
    tierStandard: '标准版',
    tierAdvanced: '高级版',
    tierBasicDesc: '适合个人开发者，基本市场数据访问',
    tierStandardDesc: '适合专业用户，包含AI分析接口',
    tierAdvancedDesc: '适合机构用户，全部接口无限制',
    ipWhitelist: 'IP 白名单',
    ipWhitelistPlaceholder: '输入IP地址，逗号分隔（如：192.168.1.1, 10.0.0.1）。留空表示不限制',
    rateLimitPerMinute: '速率限制/分钟',
    secretKeyWarning: 'Secret Key 仅在创建时显示一次，关闭后将无法再次查看。请务必妥善保存！',
    copyApiKey: '复制 API Key',
    copySecretKey: '复制 Secret Key',
    copiedToClipboard: '已复制到剪贴板',
    deactivateKey: '停用',
    deactivateConfirm: '确定要停用此 API Key 吗？停用后将无法使用该 Key 进行 API 调用。',
    editKey: '编辑',
    usageStatistics: '使用统计',
    totalRequests: '总请求数',
    avgResponseTime: '平均响应时间',
    successCount: '成功次数',
    errorCount: '错误次数',
    topEndpoints: '热门端点 Top 10',
    dailyRequests: '每日请求量',
    periodDays: '天',
    expiresAt: '过期时间',
    neverExpires: '永不过期',
    createSuccess: 'API Key 创建成功',
    keyDeactivated: 'API Key 已停用',
    keyUpdated: 'API Key 已更新',
    pythonExample: 'Python 签名示例',
    signatureExample: '签名示例代码',
    noApiKeys: '暂无 API Key，点击上方按钮创建',
    maxKeysReached: '已达到 API Key 数量上限',
    iHaveSaved: '我已保存',
    createdAt: '创建时间',
    operations: '操作',
    selectKey: '选择 Key',
    requestsPerMinute: '次/分钟',
    copyCode: '复制代码',
    basicEndpoints: '市场数据、股票列表',
    standardEndpoints: '市场数据、AI诊断、策略',
    advancedEndpoints: '全部接口无限制',
    currentPermission: '当前权限等级',
    permissionNone: '无权限',
    permissionNoneDesc: '您尚未获得 API Key 创建权限，请联系管理员开通。',
    permissionDesc: '您最高可创建 {tier} 级别的 API Key。',
    contactAdmin: '联系管理员开通',
    tierAssignedByAdmin: 'API Key 权限等级由管理员分配，创建后默认无权限。',

    // Settings — Profile
    profile: '个人资料',
    appearanceAndLanguage: '外观与语言',
    security: '安全',
    emailAddress: '邮箱',
    fullName: '姓名',
    phoneNumber: '手机号',
    registeredAt: '注册时间',
    editProfile: '编辑资料',
    profileUpdated: '资料已更新',
    profileUpdateFailed: '资料更新失败',
    usernameLocked: '用户名不可修改',

    // Settings — Appearance
    themeLight: '浅色',
    themeDark: '深色',
    languageLabel: '语言',
    themeLabel: '主题',

    // Settings — Security
    changePassword: '修改密码',
    setPassword: '设置密码',
    currentPassword: '当前密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    passwordChanged: '密码已修改',
    passwordChangeFailed: '密码修改失败',
    passwordMismatch: '两次密码不一致',
    passwordTooShort: '密码长度至少6位',
    linkedAccounts: '关联账户',
    linked: '已关联',
    notLinked: '未关联',
    noPasswordOAuth: '您通过第三方登录注册，尚未设置密码',

    // Chat Interface
    sagaxChat: 'SAGAX 对话',
    chatModeAsk: '快速回复',
    chatModeAgent: '定制投研',
    chatModePlan: '规划',
    chatModeAskDesc: '轻量模型极速响应，适合简单问答和概念解释',
    chatModeAgentDesc: '定制投研模式，可调用工具进行深度分析',
    chatModePlanDesc: '规划模式，生成并执行多步骤分析计划',
    newChat: '新对话',
    chatHistory: '历史对话',
    typeMessage: '输入消息...',
    sendMessage: '发送',
    stopGenerating: '停止生成',
    approvePlan: '批准执行',
    rejectPlan: '修改',
    planSteps: '执行计划',
    toolCalling: '工具调用',
    toolResult: '执行结果',
    today: '今天',
    yesterday: '昨天',
    previous7Days: '更早',
    noChatHistory: '暂无对话历史',
    chatWelcome: '欢迎使用 SAGAX AI',
    chatWelcomeAsk: '极速响应，快速获取投资知识和概念解释',
    chatWelcomeAgent: '我可以搜索股票、估值分析、综合评估',
    chatWelcomePlan: '我会规划并逐步执行复杂分析任务',
    deleteChat: '删除对话',
    chatEmpty: '选择模式并开始对话',
    chatThinking: '正在分析',
    chatThinkingSearch: '正在搜索',
    chatThinkingTool: '正在调用工具',

    // Agent Settings
    agentSettings: '定制投研设置',
    agentSettingsDesc: '自定义模型和参数',
    modelAsk: '快速回复模型',
    modelAgent: '定制投研模型',
    temperatureAsk: '快速回复温度',
    temperatureAgent: '定制投研温度',
    maxTokensAsk: '快速回复最大Tokens',
    maxTokensAgent: '定制投研最大Tokens',
    systemPromptExtra: '自定义系统提示',
    systemPromptExtraPlaceholder: '添加额外上下文或指令（可选）',
    languagePreference: '响应语言',
    languageAuto: '自动',
    languageZh: '中文',
    languageEn: '英文',
    saveSettings: '保存设置',
    settingsSaved: '设置已保存',
    settingsReset: '已恢复默认值',
    resetToDefault: '恢复默认',
    precise: '精确',
    creative: '创意',

    // 量化专区模块
    dataDocs: '量化专区',

    // API 文档页面
    apiDocs: 'API 文档',
    apiDocsQuickStart: '快速开始',
    apiDocsAuth: '认证方式',
    apiDocsEndpoints: 'API 端点',
    apiDocsCodeExamples: '代码示例',
    apiDocsIntro: 'SAGAX 提供 RESTful API，支持市场数据查询、AI 分析、因子数据等功能。',
    apiDocsStep1Title: '1. 获取 API Key',
    apiDocsStep1Desc: '前往设置页面创建 API Key，选择适合的权限等级。',
    apiDocsStep2Title: '2. 生成签名',
    apiDocsStep2Desc: '使用 HMAC-SHA256 算法，对请求方法、路径、时间戳和请求体进行签名。',
    apiDocsStep3Title: '3. 发送请求',
    apiDocsStep3Desc: '在请求头中携带 API Key、时间戳和签名，发送 HTTP 请求。',
    apiDocsBaseUrl: '基础 URL',
    apiDocsGoToSettings: '前往设置管理 API Key',
    apiDocsGoToSwagger: '在 Swagger UI 交互测试',
    apiDocsAuthNone: '无需认证',
    apiDocsAuthNoneDesc: '以下端点无需任何认证即可访问。',
    apiDocsAuthJwt: 'JWT 认证',
    apiDocsAuthJwtDesc: '需要用户登录后获取的 JWT Token，在 Authorization 头中携带。',
    apiDocsAuthBasic: 'Basic 级 API Key',
    apiDocsAuthBasicDesc: '需要 Basic 级别的 API Key + HMAC 签名认证。',
    apiDocsAuthStandard: 'Standard 级 API Key',
    apiDocsAuthStandardDesc: '需要 Standard 级别的 API Key + HMAC 签名认证。',
    apiDocsAuthAdvanced: 'Advanced 级 API Key',
    apiDocsAuthAdvancedDesc: '需要 Advanced 级别的 API Key + HMAC 签名认证。',
    apiDocsSignatureMethod: '签名方法',
    apiDocsSignatureDesc: '所有 API Key 认证的请求必须使用 HMAC-SHA256 签名。',
    apiDocsSignatureMessage: '签名消息格式',
    apiDocsHeaders: '请求头',
    apiDocsHeaderApiKey: 'API Key 标识',
    apiDocsHeaderTimestamp: 'Unix 时间戳（秒），5分钟内有效',
    apiDocsHeaderSignature: 'HMAC-SHA256 签名',
    apiDocsEndpointPath: '路径',
    apiDocsEndpointMethod: '方法',
    apiDocsEndpointDesc: '描述',
    apiDocsEndpointAuth: '认证',
    apiDocsPythonExample: 'Python 示例',
    apiDocsCurlExample: 'cURL 示例',
    apiDocsCopied: '已复制！',
    apiDocsCopyCode: '复制代码',
    apiDocsResponseExample: '响应示例',
    apiDocsExpandAll: '展开全部',
    apiDocsCollapseAll: '收起全部',
    apiDocsNoAuth: '无需认证',
    apiDocsRequired: '必填',
    apiDocsOptional: '可选',
    apiDocsParameters: '参数',
    apiDocsRequestBody: '请求体',

    // ====== 终端 GUI (Bloomberg-style) ======
    termF1Label: '智能',
    termF2Label: '行情',
    termF3Label: '量化',
    termF4Label: '因子',
    termF5Label: '分析',
    termF6Label: '策略',
    termF7Label: '新闻',
    termF8Label: '任务',
    termFunctionBarHint: '按 F1-F8 切换 / 点击切换',
    termStatusClock: '北京',
    termStatusUtc: 'UTC',
    termStatusSession: '会话',
    termStatusApi: '接口',
    termStatusAgents: '智能体',
    termStatusUser: '用户',
    termStatusBuild: '版本',
    termStatusOperational: '运行中',
    termStatusDegraded: '降级',
    termStatusOffline: '离线',
    termSessionPre: '盘前',
    termSessionLive: '盘中',
    termSessionClosed: '收盘',
    termSessionNight: '夜盘',
    termSessionWeekend: '周末',
    termMacroTitle: '宏观仪表板',
    termMacroSubtitle: '利率 / 收益率 / 外汇 / 商品 / 数据 / 全球',
    termMacroComingSoon: 'BETA — 6 个面板数据接入中',
    termAgenticTitle: 'Agentic 任务墙',
    termAgenticSubtitle: '实时 sagax-agent 任务监控',
    termAgenticComingSoon: 'BETA — 智能体注册与回填中',
    termPanelLoading: '加载中',
    termPanelEmpty: '暂无数据',
    termPanelError: '加载失败',
    // RAG Trace panel (Phase 2) — title stays as a bilingual literal in the
    // panel itself ('检索过程 / RAG Trace'); only section labels go through t().
    ragTaskType: '任务类型',
    ragAsset: '标的',
    ragRetrievalTargets: '检索目标',
    ragSelectedWorkflow: '使用工作流',
    ragRetrievedSources: '已检索来源',
    ragSelectedTools: '选中工具',
    ragConsideredTools: '考虑工具',
    ragFactorEvidence: '因子证据',
    ragMissingEvidence: '缺失证据',
    ragWhyRelevant: '为什么相关',
    ragNone: '无',
    ragSteps: '步骤',
    ragScore: '分数',
    ragSummaryTools: '工具',
    // Phase 2.2 — non-factor task short-circuit
    ragFactorEvidenceNotRequired: '本任务不需要因子证据',
    // Phase 3 Batch 3 — selected SOPs section
    ragSelectedSOPs: '关联 SOP',
    ragValidationRules: '条验收规则',
  },
  en: {
    // Navigation
    overview: 'Home',
    aiDiagnosis: 'AI Diagnosis',
    newsIntelligence: 'AI News Intelligence',
    shortTermPrediction: 'Short-term Forecast',
    strategyMatching: 'Strategy Matching',
    sagaxAgent: 'SAGAX Research',

    // AI News Intelligence
    newsIntelTitle: 'AI News Intelligence',
    newsIntelDesc: 'Global market news with AI-powered sentiment analysis',
    newsMapView: 'Map View',
    newsListView: 'List',
    globalNewsMonitor: 'Global News Monitor',
    newsCount: 'articles',
    regionsCount: 'regions',
    autoRefresh: 'auto-refresh',
    totalArticles: 'Total Articles',
    signalCount: 'Signals',
    sourceCount: 'Sources',
    sourceDistribution: 'Source Distribution',
    bullish: 'Bullish',
    bearish: 'Bearish',
    neutral: 'Neutral',
    breaking: 'BREAKING',
    noNewsData: 'No news data',
    loadingGlobalNews: 'Loading global news...',
    articleDetail: 'Article Detail',
    viewSource: 'Source',
    noContent: 'No content available',
    aiCredibility: 'AI Credibility Assessment',
    overall: 'Overall',
    sourceLabel: 'Source',
    contentLabel: 'Content',
    stockImpact: 'Stock Impact Assessment',
    searchNews: 'Search news...',
    impact: 'Impact',
    readMore: 'Read more →',
    // News categories
    catAll: 'All',
    catMacro: 'Macro',
    catPolicy: 'Policy',
    catIndustry: 'Industry',
    catCompany: 'Company',
    catMarket: 'Market',
    catCentralBank: 'Central Bank',
    catEarnings: 'Earnings',
    catGeopolitical: 'Geopolitical',
    catInvestmentBank: 'IB Insights',
    // Map filter modes
    filterByType: 'By Type',
    filterByRegion: 'By Region',
    // Regions
    regionAll: 'Global',
    regionChina: 'China',
    regionAsiaPacific: 'Asia Pacific',
    regionNorthAmerica: 'N. America',
    regionEurope: 'Europe',
    regionMiddleEast: 'Middle East',

    // Overview page
    majorIndices: 'Major Indices',
    realTimeData: 'Real-time Data',
    marketStatistics: 'Market Statistics',
    hotStocks: 'Hot Stocks',
    gainersList: 'Gainers List',
    losersList: 'Losers List',
    totalVolume: 'Total Volume',
    totalAmount: 'Total Amount',
    risingStocks: 'Rising Stocks',
    fallingStocks: 'Falling Stocks',
    flatStocks: 'Flat Stocks',
    tradingDate: 'Trading Date',
    noMarketData: 'No market data available',
    noGainersData: 'No gainers data available',
    noLosersData: 'No losers data available',
    gainersCount: 'Gainers Count',
    losersCount: 'Losers Count',
    
    // AI Diagnosis
    aiDiagnosisCenter: 'AI Diagnosis Center',
    intelligentQuantitativeAnalysis: 'Intelligent Quantitative Analysis, Precise Investment Decisions',
    aiDescription: 'Based on advanced artificial intelligence technology, providing comprehensive intelligent analysis services for your investment decisions. From valuation testing to trend recognition, to comprehensive evaluation, let AI become your most reliable investment partner.',
    valuationTest: 'Valuation Test',
    trendRecognition: 'Trend Recognition',
    comprehensiveEvaluation: 'Comprehensive Evaluation',
    usageInstructions: 'Usage Instructions',
    quickStart: 'Quick Start',
    technicalFeatures: 'Technical Features',
    step1: 'Select the analysis module you need',
    step2: 'Enter stock code or futures code',
    step3: 'Get AI intelligent analysis results',
    deepLearningAlgorithm: 'Deep Learning Algorithm',
    realTimeDataProcessing: 'Real-time Data Processing',
    multiDimensionalAnalysis: 'Multi-dimensional Analysis',

    // Strategy Matching
    strategyDescription: 'Our managers provide a diverse range of strategies across investment approaches, styles, and asset classes.',
    approach: 'Approach',
    style: 'Style',
    assetClass: 'Asset Class',
    reset: 'RESET',
    activeStrategies: 'Active Strategies',
    averagePerformance: 'Average Performance',
    
    // Strategy Matching detailed translations
    discretionary: 'Discretionary',
    multiManager: 'Multi-manager',
    quantitative: 'Quantitative',
    alternative: 'Alternative',
    longOnly: 'Long-only',
    privateMarkets: 'Private Markets',
    equity: 'Equity',
    credit: 'Credit',
    multiAsset: 'Multi-asset',
    realEstate: 'Real Estate',
    performance: 'Performance',
    risk: 'Risk',
    status: 'Status',
    active: 'Active',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    trendFollowing: 'Trend-following',
    trendFollowingLiquid: 'Trend-following liquid OTC',
    trendFollowingOTC: 'Trend-following OTC',
    catastropheBond: 'Catastrophe Bond',
    multiStrategy: 'Multi-strategy',
    systematicMacro: 'Systematic Macro',
    targetClimate: 'TargetClimate',
    longOnlyStrategy: 'Long only',
    
    // Stock prediction related
    futuresHeatmap: 'A-Stock Heatmap',
    stockHeatmap: 'A-Stock Heatmap',
    futuresHeatmapDescription: 'AI-based A-stock short-term price prediction heatmap',
    stockHeatmapDescription: 'AI-based A-stock short-term price prediction heatmap',
    fiveDayPriceChange: 'Five-day Price Change Heatmap',
    clickFuturesCode: 'Click stock code to view detailed time price series prediction',
    clickStockCode: 'Click stock code to view detailed time price series prediction',
    falling: 'Falling',
    rising: 'Rising',
    green: 'Green',
    white: 'White',
    red: 'Red',
    changeRange: 'Change Range Heatmap (±10%)',
    varietyDate: 'Stock/Date',
    updateTime: 'Update Time',
    clickFuturesCodeDetail: 'Click stock code to view detailed time price series prediction',
    clickStockCodeDetail: 'Click stock code to view detailed time price series prediction',
    colorDepth: 'Color depth indicates change range, values indicate confidence',
    predictionAutoRefresh: 'Data auto-refreshes every 30 seconds, based on AI model real-time prediction',
    
    // Stock detail
    currentPrice: 'Current Price',
    volume: 'Volume',
    peRatio: 'PE Ratio',
    pbRatio: 'PB Ratio',
    totalMarketValue: 'Total Market Value',
    circulatedMarketValue: 'Circulated Market Value',
    openInterest: 'Open Interest',
    margin: 'Margin',
    ratio: 'Ratio',
    contractInfo: 'Contract Information',
    contractSize: 'Contract Size',
    minTickSize: 'Minimum Tick Size',
    tradingVariety: 'Trading Variety',
    exchange: 'Exchange',
    hand: 'Hand',
    exportData: 'Export',
    share: 'Share',
    dataExportInDevelopment: 'Data export feature under development...',
    linkCopied: 'Link copied to clipboard',
    oneDay: '1 Day',
    threeDays: '3 Days',
    fiveDays: '5 Days',
    sevenDays: '7 Days',
    oneMonth: '1 Month',
    unknownFutures: 'Unknown Stock',
    unknownStock: 'Unknown Stock',
    unknown: 'Unknown',
    unknownExchange: 'Unknown Exchange',
    
    // Trend recognition
    commodityTrendRecognition: 'Commodity Trend Recognition',
    commodityTrendDescription: 'AI-based commodity futures trend analysis tool',
    inputArea: 'Input Area',
    futuresSelection: 'Futures Selection',
    futuresCode: 'Futures Code',
    quickSelection: 'Quick Selection',
    selectFutures: 'Select Futures',
    startTrendAnalysis: 'Start Trend Analysis',
    analyzing: 'Analyzing...',
    viewHeatmap: 'View Heatmap',
    resultArea: 'Result Area',
    analysisResult: 'Analysis Result',
    futuresInfo: 'Futures Information',
    code: 'Code',
    name: 'Name',
    currentPriceValue: 'Current Price',
    technicalIndicators: 'Technical Indicators',
    bollUpper: 'Bollinger Upper',
    bollLower: 'Bollinger Lower',
    trendAnalysis: 'Trend Analysis',
    trendDirection: 'Trend Direction',
    trendStrength: 'Trend Strength',
    supportLevel: 'Support Level',
    resistanceLevel: 'Resistance Level',
    detailedAnalysis: 'Detailed Analysis',
    noDetailedAnalysis: 'No detailed analysis available',
    pleaseSelectFutures: 'Please select futures and start analysis',
    enterFuturesCode: 'Please enter futures code',
    analysisFailed: 'Analysis failed',
    getFuturesListFailed: 'Failed to get futures list',
    
    // Data processing
    dataProcessing: 'Data Processing',
    dataProcessingDescription: 'Intelligent data acquisition, cleaning and indicator calculation',
    dataProcessingModule: 'Data Processing Module',
    dataProcessingInDevelopment: 'This module is under development and will provide intelligent data processing functions',
    dataAcquisition: 'Data Acquisition',
    indicatorCalculation: 'Indicator Calculation',
    
    // Factor Dashboard
    factorDashboard: 'Factor Dashboard',
    factorDashboardDescription: 'Factor Dashboard and Analysis Description',
    factorDashboardAnalysis: 'Factor Dashboard and Analysis Description',
    factorDashboardPlaceholder: 'Factor dashboard feature under development, will provide comprehensive factor analysis',
    configuration: 'Configuration',
    category: 'Category',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    stockPool: 'Stock Pool',
    backtestPeriod: 'Backtest Period',
    portfolioConstruction: 'Portfolio Construction',
    transactionCosts: 'Transaction Fees and Slippage',
    filterStocks: 'Filter Daily Limit Up/Down and Suspended Stocks',
    factorData: 'Factor Data',
    minQuantileReturn: 'Min Quantile Excess Annualized Return',
    maxQuantileReturn: 'Max Quantile Excess Annualized Return',
    minQuantileTurnover: 'Min Quantile Turnover Rate',
    maxQuantileTurnover: 'Max Quantile Turnover Rate',
    irValue: 'IR Value',

    // Automated trading
    automatedTrading: 'Automated Trading',
    automatedTradingDescription: 'Fully automated trading execution and risk management',
    automatedTradingModule: 'Automated Trading Module',
    automatedTradingInDevelopment: 'This module is under development and will provide fully automated trading execution functions',
    autoTrading: 'Auto Trading',
    riskControl: 'Risk Control',
    
    // Common
    symbol: 'symbol',
    switchToEnglish: 'Switch to English',
    switchToChinese: 'Switch to Chinese',
    chinese: '中',
    english: 'EN',
    loading: 'Loading...',
    noData: 'No data available',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    search: 'Search',
    filter: 'Filter',
    refresh: 'Refresh',
    more: 'More',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    close: 'Close',
    open: 'Open',
    view: 'View',
    download: 'Download',
    upload: 'Upload',
    export: 'Export',
    import: 'Import',

    // Factor Agent
    factorGeneration: 'Factor Generation',
    factorGenerationDesc: 'Generate quantitative factor code from natural language descriptions with AI evaluation',
    factorReview: 'Factor Review',
    factorReviewDesc: 'View, review and manage AI-generated factors',
    generateFactor: 'Generate Factor',
    factorDescription: 'Factor Description',
    factorName: 'Factor Name',
    factorType: 'Factor Type',
    dependencies: 'Dependencies',
    generating: 'Generating...',
    compositeScore: 'Composite Score',
    backtestMetrics: 'Backtest Metrics',
    verificationChecks: 'Verification Checks',
    icMean: 'IC Mean',
    icRatio: 'IC Ratio',
    icWinRate: 'IC Win Rate',
    sharpeRatio: 'Sharpe Ratio',
    approveAndRegister: 'Approve & Register',
    rejectFactor: 'Reject',
    pendingReview: 'Pending Review',
    approved: 'Approved',
    rejected: 'Rejected',
    iterationHistory: 'Iteration History',
    generatedCode: 'Generated Code',
    explanation: 'Explanation',
    registeredFactors: 'Registered Factors',

    // Settings page
    settings: 'Settings',
    apiKeyManagement: 'API Key Management',
    createApiKey: 'Create API Key',
    apiKeyList: 'API Key List',
    apiKeyName: 'API Key Name',
    tierBasic: 'Basic',
    tierStandard: 'Standard',
    tierAdvanced: 'Advanced',
    tierBasicDesc: 'For individual developers, basic market data access',
    tierStandardDesc: 'For professional users, includes AI analysis endpoints',
    tierAdvancedDesc: 'For institutional users, unrestricted access to all endpoints',
    ipWhitelist: 'IP Whitelist',
    ipWhitelistPlaceholder: 'Enter IP addresses, comma-separated (e.g., 192.168.1.1, 10.0.0.1). Leave empty for no restriction',
    rateLimitPerMinute: 'Rate Limit/min',
    secretKeyWarning: 'The Secret Key is only shown once at creation. It cannot be viewed again after closing. Please save it securely!',
    copyApiKey: 'Copy API Key',
    copySecretKey: 'Copy Secret Key',
    copiedToClipboard: 'Copied to clipboard',
    deactivateKey: 'Deactivate',
    deactivateConfirm: 'Are you sure you want to deactivate this API Key? It will no longer be usable for API calls.',
    editKey: 'Edit',
    usageStatistics: 'Usage Statistics',
    totalRequests: 'Total Requests',
    avgResponseTime: 'Avg Response Time',
    successCount: 'Successes',
    errorCount: 'Errors',
    topEndpoints: 'Top 10 Endpoints',
    dailyRequests: 'Daily Requests',
    periodDays: 'days',
    expiresAt: 'Expires At',
    neverExpires: 'Never expires',
    createSuccess: 'API Key created successfully',
    keyDeactivated: 'API Key deactivated',
    keyUpdated: 'API Key updated',
    pythonExample: 'Python Signature Example',
    signatureExample: 'Signature Example Code',
    noApiKeys: 'No API Keys yet. Click the button above to create one',
    maxKeysReached: 'Maximum number of API Keys reached',
    iHaveSaved: 'I have saved it',
    createdAt: 'Created At',
    operations: 'Actions',
    selectKey: 'Select Key',
    requestsPerMinute: 'req/min',
    copyCode: 'Copy Code',
    basicEndpoints: 'Market data, stock lists',
    standardEndpoints: 'Market data, AI diagnosis, strategies',
    advancedEndpoints: 'All endpoints unrestricted',
    currentPermission: 'Current Permission',
    permissionNone: 'No Permission',
    permissionNoneDesc: 'You do not have permission to create API Keys. Please contact the administrator.',
    permissionDesc: 'You can create API Keys up to {tier} tier.',
    contactAdmin: 'Contact Admin',
    tierAssignedByAdmin: 'API Key permission tier is assigned by admins. Newly created keys have no permission by default.',

    // Settings — Profile
    profile: 'Profile',
    appearanceAndLanguage: 'Appearance & Language',
    security: 'Security',
    emailAddress: 'Email',
    fullName: 'Full Name',
    phoneNumber: 'Phone',
    registeredAt: 'Registered',
    editProfile: 'Edit Profile',
    profileUpdated: 'Profile updated',
    profileUpdateFailed: 'Failed to update profile',
    usernameLocked: 'Username cannot be changed',

    // Settings — Appearance
    themeLight: 'Light',
    themeDark: 'Dark',
    languageLabel: 'Language',
    themeLabel: 'Theme',

    // Settings — Security
    changePassword: 'Change Password',
    setPassword: 'Set Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    passwordChanged: 'Password changed',
    passwordChangeFailed: 'Failed to change password',
    passwordMismatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 6 characters',
    linkedAccounts: 'Linked Accounts',
    linked: 'Linked',
    notLinked: 'Not linked',
    noPasswordOAuth: 'You signed up via third-party login and have not set a password',

    // Chat Interface
    sagaxChat: 'SAGAX Chat',
    chatModeAsk: 'Quick Reply',
    chatModeAgent: 'Research',
    chatModePlan: 'Plan',
    chatModeAskDesc: 'Lightweight model for instant responses to simple questions',
    chatModeAgentDesc: 'Custom research mode with tool access for deep analysis',
    chatModePlanDesc: 'Plan mode to generate and execute multi-step analysis',
    newChat: 'New Chat',
    chatHistory: 'Chat History',
    typeMessage: 'Type a message...',
    sendMessage: 'Send',
    stopGenerating: 'Stop generating',
    approvePlan: 'Approve & Execute',
    rejectPlan: 'Modify',
    planSteps: 'Plan Steps',
    toolCalling: 'Arguments',
    toolResult: 'Result',
    today: 'Today',
    yesterday: 'Yesterday',
    previous7Days: 'Earlier',
    noChatHistory: 'No chat history',
    chatWelcome: 'Welcome to SAGAX AI',
    chatWelcomeAsk: 'Instant responses for investment knowledge and concept explanations',
    chatWelcomeAgent: 'I can search stocks, run valuations, and comprehensive evaluations',
    chatWelcomePlan: 'I will plan and execute complex analysis tasks step by step',
    deleteChat: 'Delete chat',
    chatEmpty: 'Choose a mode and start chatting',
    chatThinking: 'Analyzing',
    chatThinkingSearch: 'Searching',
    chatThinkingTool: 'Using tools',

    // Agent Settings
    agentSettings: 'Research Settings',
    agentSettingsDesc: 'Customize models and parameters',
    modelAsk: 'Quick Reply Model',
    modelAgent: 'Research Model',
    temperatureAsk: 'Quick Reply Temperature',
    temperatureAgent: 'Research Temperature',
    maxTokensAsk: 'Quick Reply Max Tokens',
    maxTokensAgent: 'Research Max Tokens',
    systemPromptExtra: 'Custom System Prompt',
    systemPromptExtraPlaceholder: 'Add extra context or instructions (optional)',
    languagePreference: 'Response Language',
    languageAuto: 'Auto',
    languageZh: 'Chinese',
    languageEn: 'English',
    saveSettings: 'Save Settings',
    settingsSaved: 'Settings saved',
    settingsReset: 'Reset to defaults',
    resetToDefault: 'Reset to Default',
    precise: 'Precise',
    creative: 'Creative',

    // Quant Zone module
    dataDocs: 'Quant Zone',

    // API Docs page
    apiDocs: 'API Docs',
    apiDocsQuickStart: 'Quick Start',
    apiDocsAuth: 'Authentication',
    apiDocsEndpoints: 'API Endpoints',
    apiDocsCodeExamples: 'Code Examples',
    apiDocsIntro: 'SAGAX provides RESTful APIs for market data queries, AI analysis, factor data, and more.',
    apiDocsStep1Title: '1. Get API Key',
    apiDocsStep1Desc: 'Go to the Settings page to create an API Key and choose the appropriate permission tier.',
    apiDocsStep2Title: '2. Generate Signature',
    apiDocsStep2Desc: 'Use HMAC-SHA256 to sign the request method, path, timestamp, and body.',
    apiDocsStep3Title: '3. Send Request',
    apiDocsStep3Desc: 'Include the API Key, timestamp, and signature in request headers.',
    apiDocsBaseUrl: 'Base URL',
    apiDocsGoToSettings: 'Go to Settings to manage API Keys',
    apiDocsGoToSwagger: 'Interactive testing in Swagger UI',
    apiDocsAuthNone: 'No Authentication',
    apiDocsAuthNoneDesc: 'These endpoints can be accessed without any authentication.',
    apiDocsAuthJwt: 'JWT Authentication',
    apiDocsAuthJwtDesc: 'Requires a JWT token obtained after login, sent in the Authorization header.',
    apiDocsAuthBasic: 'Basic Tier API Key',
    apiDocsAuthBasicDesc: 'Requires a Basic tier API Key with HMAC signature authentication.',
    apiDocsAuthStandard: 'Standard Tier API Key',
    apiDocsAuthStandardDesc: 'Requires a Standard tier API Key with HMAC signature authentication.',
    apiDocsAuthAdvanced: 'Advanced Tier API Key',
    apiDocsAuthAdvancedDesc: 'Requires an Advanced tier API Key with HMAC signature authentication.',
    apiDocsSignatureMethod: 'Signature Method',
    apiDocsSignatureDesc: 'All API Key authenticated requests must use HMAC-SHA256 signatures.',
    apiDocsSignatureMessage: 'Signature Message Format',
    apiDocsHeaders: 'Request Headers',
    apiDocsHeaderApiKey: 'API Key identifier',
    apiDocsHeaderTimestamp: 'Unix timestamp (seconds), valid within 5 minutes',
    apiDocsHeaderSignature: 'HMAC-SHA256 signature',
    apiDocsEndpointPath: 'Path',
    apiDocsEndpointMethod: 'Method',
    apiDocsEndpointDesc: 'Description',
    apiDocsEndpointAuth: 'Auth',
    apiDocsPythonExample: 'Python Example',
    apiDocsCurlExample: 'cURL Example',
    apiDocsCopied: 'Copied!',
    apiDocsCopyCode: 'Copy Code',
    apiDocsResponseExample: 'Response Example',
    apiDocsExpandAll: 'Expand All',
    apiDocsCollapseAll: 'Collapse All',
    apiDocsNoAuth: 'No Auth',
    apiDocsRequired: 'Required',
    apiDocsOptional: 'Optional',
    apiDocsParameters: 'Parameters',
    apiDocsRequestBody: 'Request Body',

    // ====== Terminal GUI (Bloomberg-style) ======
    termF1Label: 'AGENT',
    termF2Label: 'MARKETS',
    termF3Label: 'QUANT',
    termF4Label: 'FACTOR',
    termF5Label: 'ANALYSIS',
    termF6Label: 'STRAT',
    termF7Label: 'NEWS',
    termF8Label: 'TASKS',
    termFunctionBarHint: 'Press F1-F8 / click to switch',
    termStatusClock: 'SHA',
    termStatusUtc: 'UTC',
    termStatusSession: 'SESSION',
    termStatusApi: 'API',
    termStatusAgents: 'AGENTS',
    termStatusUser: 'USER',
    termStatusBuild: 'BUILD',
    termStatusOperational: 'OPERATIONAL',
    termStatusDegraded: 'DEGRADED',
    termStatusOffline: 'OFFLINE',
    termSessionPre: 'PRE-MKT',
    termSessionLive: 'LIVE',
    termSessionClosed: 'CLOSED',
    termSessionNight: 'NIGHT',
    termSessionWeekend: 'WEEKEND',
    termMacroTitle: 'Macro Dashboard',
    termMacroSubtitle: 'Rates / Yields / FX / Commodities / Releases / Global',
    termMacroComingSoon: 'BETA — 6 panels loading',
    termAgenticTitle: 'Agentic Task Wall',
    termAgenticSubtitle: 'Real-time sagax-agent task monitoring',
    termAgenticComingSoon: 'BETA — agent registry & backfill in progress',
    termPanelLoading: 'LOADING',
    termPanelEmpty: 'NO DATA',
    termPanelError: 'ERROR',
    // RAG Trace panel (Phase 2)
    ragTaskType: 'Task Type',
    ragAsset: 'Asset',
    ragRetrievalTargets: 'Retrieval Targets',
    ragSelectedWorkflow: 'Selected Workflow',
    ragRetrievedSources: 'Retrieved Sources',
    ragSelectedTools: 'Selected Tools',
    ragConsideredTools: 'Considered Tools',
    ragFactorEvidence: 'Factor Evidence',
    ragMissingEvidence: 'Missing Evidence',
    ragWhyRelevant: 'Why Relevant',
    ragNone: 'None',
    ragSteps: 'steps',
    ragScore: 'score',
    ragSummaryTools: 'tools',
    // Phase 2.2 — non-factor task short-circuit
    ragFactorEvidenceNotRequired: 'Not required for this task',
    // Phase 3 Batch 3 — selected SOPs section
    ragSelectedSOPs: 'Selected SOPs',
    ragValidationRules: 'validation rules',
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('sagax-language') || 'zh';
    // Set data-lang on <html> immediately so CSS can hide <main> before first paint
    if (saved === 'en') {
      document.documentElement.dataset.lang = 'en';
    }
    return saved;
  });

  useEffect(() => {
    localStorage.setItem('sagax-language', language);
    // Sync data-lang attribute for CSS-based content hiding
    if (language === 'en') {
      document.documentElement.dataset.lang = 'en';
    } else {
      delete document.documentElement.dataset.lang;
    }
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'zh' ? 'en' : 'zh');
  };

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    t
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
